import SideBar from './side_bar';

export default SideBar;
